<template>
  <IconLucideBox />
</template>
